export default __webpack_public_path__ + "static/media/information--bicycles-crossing--g2.bf76e715.png";